import { render } from "./Change-product.vue?vue&type=template&id=16e5d089&scoped=true"
import script from "./Change-product.vue?vue&type=script&lang=js"
export * from "./Change-product.vue?vue&type=script&lang=js"

import "./Change-product.vue?vue&type=style&index=0&id=16e5d089&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e5d089"]])

export default __exports__